import { render } from "./Chicken.vue?vue&type=template&id=2df22da4"
import script from "./Chicken.vue?vue&type=script&lang=js"
export * from "./Chicken.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__